module.exports = __webpack_public_path__ + "img/AppointmentTypes.b58bb034.svg";